module.exports = __webpack_public_path__ + "img/manageTopic-active.eacea809.svg";